import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CUSTOM_STYLE } from './utils/configAppBarStyle';
import UserGuide from './content/FaVacBidUserGuide.pdf';

import { Container, CssBaseline } from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { Button } from '@material-ui/core';

import MenuIcon from '@material-ui/icons/Menu';
// import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import { Route, Link } from 'react-router-dom';
import Home from './components/Home';
import Yearly from './components/yearly/Yearly';
import Info from './components/info/Info';
import Calendar from './components/calendar/Calendar';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        flexGrow: 1,
        textDecoration: 'none',
    },
    menu: {
        marginTop: theme.spacing(6),
    },
    btnLink:{
        textDecoration: 'none',
        color: 'white',
        textTransform: 'none',
        backgroundColor: "#172785",
    }
}));

const buttonStyle = {
    textDecoration: 'none',
    color: 'white',
    textTransform: 'none',
    backgroundColor: CUSTOM_STYLE.btn
}

function App() {

    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    // const [anchorEl2, setAnchorEl2] = React.useState(null);

    const handleNavMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleNavMenuClose = () => {
        setAnchorEl(null);
    };

    // const handleDropDownClick = (event) => {
    //     setAnchorEl2(event.currentTarget);
    // };

    // const handleDropDownClose = () => {
    //     setAnchorEl2(null);
    // }

  return (
    <>
        <CssBaseline />
        <AppBar position="static" style={CUSTOM_STYLE.appBar}>
            <Toolbar>
                <IconButton edge="start" className={classes.menuButton} color="inherit" onClick={handleNavMenuClick}>
                    <MenuIcon />
                </IconButton>
                <Menu
                    className={classes.menu}
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleNavMenuClose}
                >
                    <MenuItem component={Link} to={'/yearly'} onClick={handleNavMenuClose}>Yearly Bidding</MenuItem>
                    <MenuItem component={Link} to={'/info'} onClick={handleNavMenuClose}>View Info</MenuItem>
                    <MenuItem component={Link} to={'/calendar'} onClick={handleNavMenuClose}>Calendar</MenuItem>
                </Menu>
                <Typography variant="h6" className={classes.title} component={Link} to={'/'} color="inherit">
                    FA Vacation Bidding
                </Typography>
                {/* <IconButton edge="start" color="inherit" onClick={handleDropDownClick}>
                    <ArrowDropDownIcon />
                </IconButton> */}
                {/* <Menu
                    className={classes.menu}
                    anchorEl={anchorEl2}
                    open={Boolean(anchorEl2)}
                    onClose={handleDropDownClose}
                >
                    <MenuItem component={Link} to={UserGuide} onClick={handleDropDownClose} target="_blank" rel="noopener noreferrer">User Guide</MenuItem>
                </Menu> */}
                <Button variant="contained" style={buttonStyle} component={Link} to={UserGuide} target="_blank" rel="noopener noreferrer">User Guide</Button>
            </Toolbar>
        </AppBar>
        <Container>
            <Route exact path='/' component={Home} />
            <Route path='/yearly' component={Yearly} />
            <Route path='/info' component={Info} />
            <Route path='/calendar' component={Calendar} />
        </Container>
    </> 
  );
}

export default App;
